import {openapi_website_cms_updateMarketsForSport, Response200Type, decodeResponse200 } from 'src/api_openapi/generated/openapi_website_cms_updateMarketsForSport';
import { MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType } from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';

export type UpdateMarketsForSportType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface UpdateMarketsForSportParams {
    markets: Array<MarketUpdateParams>,
}

interface MarketUpdateParams {
    display_order: number,
    market_id: number,
}

export const updateMarketsForSport = {
    browser: {
        params: (params: UpdateMarketsForSportParams): ParamsFetchType<UpdateMarketsForSportParams> => {
            return {
                type: MethodType.PATCH,
                url: '/api-web/update-markets',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.PATCH,
        urlBrowser: '/api-web/update-markets',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<UpdateMarketsForSportParams>): Promise<GenerateUrlApiType> => {

        const resp = await openapi_website_cms_updateMarketsForSport(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.markets
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body
        };
    }
};
